import './i18n/config';
import { ReactNode } from 'react';
import { createGlobalStyle } from 'styled-components';
import { ScreenClassProvider, SWAN_STYLE_KEY_MAP, useBrowserClasses } from '@vp/swan';
import { useSwanStyleKeys } from '@vp/ubik-context';
import { AuthContextProvider } from './auth';
import { sanitiseLocale } from './i18n/config';
import { DefaultPageTrackingParams, DefaultPageTrackingParamsContext } from './utils/analytics';
import { EnvironmentContext } from './utils/environmentContext';
import type { Locale } from './i18n/config';
import type { EnvironmentContextType } from './utils/environmentContext';

interface AppProps {
    defaultPageTrackingParams: DefaultPageTrackingParams;
    locale: Locale;
    envContext: EnvironmentContextType;
    children: ReactNode;
}

const GlobalStyle = createGlobalStyle`
  body {
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .swan-dialog:not([open]).swan-dialog:not([open]) {
    display: none;
  }
`;

export const App = ({ defaultPageTrackingParams, locale, envContext, children }: AppProps) => {
    const styleSheetKeys = [
        SWAN_STYLE_KEY_MAP.button,
        SWAN_STYLE_KEY_MAP.accordion,
        SWAN_STYLE_KEY_MAP.grid,
        SWAN_STYLE_KEY_MAP.modalDialog,
        SWAN_STYLE_KEY_MAP.hidden,
        SWAN_STYLE_KEY_MAP.icon,
        SWAN_STYLE_KEY_MAP.toggleSwitch,
        SWAN_STYLE_KEY_MAP.core,
        SWAN_STYLE_KEY_MAP.visible,
        SWAN_STYLE_KEY_MAP.standardTile,
        SWAN_STYLE_KEY_MAP.progressiveImage,
        SWAN_STYLE_KEY_MAP.utility,
        SWAN_STYLE_KEY_MAP.tabs,
        SWAN_STYLE_KEY_MAP.alertBox,
        SWAN_STYLE_KEY_MAP.popover,
        SWAN_STYLE_KEY_MAP.banner,
        SWAN_STYLE_KEY_MAP.spinner,
        SWAN_STYLE_KEY_MAP.fieldSet,
        SWAN_STYLE_KEY_MAP.carousel,
        SWAN_STYLE_KEY_MAP.anchorBar,
        SWAN_STYLE_KEY_MAP.ratingsStars,
        SWAN_STYLE_KEY_MAP.pricing,
    ];
    useSwanStyleKeys(styleSheetKeys);
    useBrowserClasses(true);

    return (
        <AuthContextProvider locale={sanitiseLocale(locale)}>
            <ScreenClassProvider>
                <GlobalStyle />
                <DefaultPageTrackingParamsContext.Provider value={defaultPageTrackingParams}>
                    <EnvironmentContext.Provider value={envContext}>
                        {children}
                    </EnvironmentContext.Provider>
                </DefaultPageTrackingParamsContext.Provider>
            </ScreenClassProvider>
        </AuthContextProvider>
    );
};
